import { BBDTag } from '@gravitate-js/excalibrr'
import React from 'react'

/**
 * Action helper functions for Recent Activity - matching the History component implementation
 * These functions provide consistent styling between Recent Activity and Match History
 */

export function getActionIcon(actionType: string): string {
  if (!actionType) return 'history'
  switch (actionType) {
    case 'invoice_added':
      return 'add_circle'
    case 'invoice_removed':
      return 'remove_circle'
    case 'bol_added':
      return 'description'
    case 'bol_removed':
      return 'cancel'
    case 'invoice_voided':
      return 'block'
    case 'invoice_unvoided':
      return 'check_circle'
    case 'match_approved':
      return 'check_circle'
    case 'hold_set':
      return 'pause_circle'
    case 'hold_removed':
      return 'play_circle'
    case 'status_changed':
      return 'sync_alt'
    case 'match_updated':
      return 'update'
    case 'documents_updated':
      return 'edit_document'
    case 'match_linked':
      return 'link'
    case 'match_unlinked':
      return 'link_off'
    case 'document_unlinked':
      return 'link_off'
    case 'document_linked':
      return 'link'
    case 'match_split':
      return 'call_split'
    case 'match_merged':
      return 'call_merge'
    case 'comment':
      return 'notifications'
    default:
      return 'history'
  }
}

export function getActionColor(actionType: string): string {
  if (!actionType) return 'var(--theme-text-secondary)'
  switch (actionType) {
    case 'invoice_added':
    case 'bol_added':
      return 'var(--theme-color-2)'
    case 'invoice_removed':
    case 'bol_removed':
      return 'var(--theme-error)'
    case 'invoice_voided':
      return 'var(--theme-error)'
    case 'invoice_unvoided':
      return 'var(--theme-color-2)'
    case 'match_approved':
      return 'var(--theme-success)'
    case 'hold_set':
      return 'var(--theme-warning)'
    case 'hold_removed':
      return 'var(--theme-color-2)'
    case 'status_changed':
      return 'var(--theme-color-1)'
    case 'match_updated':
      return 'var(--theme-color-1)'
    case 'documents_updated':
      return 'var(--theme-color-1)'
    case 'match_linked':
      return 'var(--theme-success)'
    case 'match_unlinked':
      return 'var(--theme-warning)'
    case 'document_unlinked':
      return 'var(--theme-error)'
    case 'document_linked':
      return 'var(--theme-success)'
    case 'match_split':
      return 'var(--theme-warning)'
    case 'match_merged':
      return 'var(--theme-success)'
    case 'comment':
      return 'var(--theme-text-secondary)'
    default:
      return 'var(--theme-text-secondary)'
  }
}

export function getActionTagProps(actionType: string): {
  success?: boolean
  warning?: boolean
  error?: boolean
  theme2?: boolean
  text: string
} {
  if (!actionType) return { text: 'UNKNOWN' }

  switch (actionType) {
    case 'invoice_added':
      return { theme2: true, text: 'INVOICE ADDED' }
    case 'invoice_removed':
      return { error: true, text: 'INVOICE REMOVED' }
    case 'bol_added':
      return { theme2: true, text: 'BOL ADDED' }
    case 'bol_removed':
      return { error: true, text: 'BOL REMOVED' }
    case 'invoice_voided':
      return { error: true, text: 'VOIDED' }
    case 'invoice_unvoided':
      return { theme2: true, text: 'UNVOIDED' }
    case 'match_approved':
      return { success: true, text: 'APPROVED' }
    case 'hold_set':
      return { warning: true, text: 'ON HOLD' }
    case 'hold_removed':
      return { theme2: true, text: 'HOLD REMOVED' }
    case 'status_changed':
      return { theme2: true, text: 'STATUS CHANGED' }
    case 'match_updated':
      return { theme2: true, text: 'MATCH UPDATED' }
    case 'documents_updated':
      return { theme2: true, text: 'DOCUMENTS UPDATED' }
    case 'match_linked':
      return { success: true, text: 'LINKED' }
    case 'match_unlinked':
      return { warning: true, text: 'UNLINKED' }
    case 'document_unlinked':
      return { error: true, text: 'DOCUMENT UNLINKED' }
    case 'document_linked':
      return { success: true, text: 'DOCUMENT LINKED' }
    case 'match_split':
      return { warning: true, text: 'MATCH SPLIT' }
    case 'match_merged':
      return { success: true, text: 'MATCH MERGED' }
    case 'comment':
      return { text: 'COMMENT' }
    default:
      return { text: actionType.replace(/_/g, ' ').toUpperCase() }
  }
}
